<script lang="ts" setup></script>

<template>
  <Blog1Title />
  <Blog2ItemsHot />
  <Blog3ItemsNormal />
</template>
